import { Issue } from './components/Issue';

export const StepFour = () => <Issue />;
